import React from 'react';
import styled from 'styled-components';
import { colors } from '../styles/colors';
import { AppStoreButtons } from '../components/AppStoreButtons';

const FooterContainer = styled.footer`
  background: ${colors.textPrimary};
  color: white;
  padding: 80px 0 40px;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  
  @media (max-width: 768px) {
    max-width: 100%;
    margin: 0;
    padding: 0 20px;
  }
  
  @media (max-width: 480px) {
    padding: 0 16px;
  }
`;

const FooterTop = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 60px;
  margin-bottom: 60px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

const FooterSection = styled.div``;

const FooterTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 24px;
  color: white;
`;

const FooterText = styled.p`
  font-size: 14px;
  line-height: 1.6;
  color: ${colors.textTertiary};
  margin-bottom: 16px;
`;

const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const FooterLink = styled.a`
  font-size: 14px;
  color: ${colors.textTertiary};
  text-decoration: none;
  transition: color 0.2s ease;
  
  &:hover {
    color: white;
  }
`;

const CompanyInfo = styled.div`
  font-size: 12px;
  color: ${colors.textTertiary};
  line-height: 1.5;
  
  p {
    margin-bottom: 8px;
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid ${colors.secondaryDark};
  padding-top: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 24px;
    text-align: center;
  }
`;

const Copyright = styled.p`
  font-size: 12px;
  color: ${colors.textTertiary};
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

const CTASection = styled.div`
  text-align: center;
  background: linear-gradient(135deg, ${colors.primary}, ${colors.primaryLight});
  padding: 60px 40px;
  border-radius: 24px;
  margin-bottom: 60px;
`;

const CTATitle = styled.h2`
  font-size: 36px;
  font-weight: 700;
  color: white;
  margin-bottom: 16px;
  
  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

const CTASubtitle = styled.p`
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 32px;
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const Footer: React.FC = () => {
  return (
    <FooterContainer data-section="footer">
      <FooterContent>
        <CTASection>
          <CTATitle>지금 시작하세요</CTATitle>
          <CTASubtitle>
            투자의 전설들과 함께하는 똑똑한 투자 여정
          </CTASubtitle>
          <AppStoreButtons
            googlePlayUrl="https://play.google.com/store/apps/details?id=com.tobeAi.tobe"
            appStoreUrl="https://apps.apple.com/us/app/%ED%88%AC%EB%B9%84/id6749519861"
          />
        </CTASection>

        <FooterTop>
          <FooterSection>
            <FooterTitle>투비</FooterTitle>
            <FooterText>
              투자의 전설들이 당신만의 AI 멘토가 되어
              <br />
              더 나은 투자 결정을 도와드립니다.
            </FooterText>
            <CompanyInfo>
              <p>문의: tobe@tobeai.xyz</p>
            </CompanyInfo>
          </FooterSection>

          <FooterSection>
            <FooterTitle>서비스</FooterTitle>
            <FooterLinks>
              <FooterLink href="#features">주요 기능</FooterLink>
              <FooterLink href="#mentors">투자 멘토</FooterLink>
              <FooterLink href="https://tobeai-cs.web.app/" target="_blank" rel="noopener noreferrer">고객센터</FooterLink>
            </FooterLinks>
          </FooterSection>

          <FooterSection>
            <FooterTitle>정보</FooterTitle>
            <FooterLinks>
              <FooterLink href="https://tobeai-cs.web.app/terms" target="_blank" rel="noopener noreferrer">이용약관</FooterLink>
              <FooterLink href="https://tobeai-cs.web.app/privacy" target="_blank" rel="noopener noreferrer">개인정보처리방침</FooterLink>
              <FooterLink href="https://tobeai-cs.web.app/" target="_blank" rel="noopener noreferrer">고객센터</FooterLink>
            </FooterLinks>
          </FooterSection>
        </FooterTop>

        <FooterBottom>
          <Copyright>
            © 2024 투비. All rights reserved.
          </Copyright>
          <SocialLinks>
            <FooterText>tobe@tobeai.xyz</FooterText>
          </SocialLinks>
        </FooterBottom>
      </FooterContent>
    </FooterContainer>
  );
}; 